<template>
  <div class="fill-height">
        <v-container fluid class="mt-0 pt-6">
            <div class="grid grid-flow-row grid-cols-3 grid-rows-3 gap-4 bg-black">
                <div id="video-chat-window"></div>
                <v-card
                    class="d-flex align-center justify-center mb-6"
                    flat
                    height="calc(100vh - 194px)"
                    tile
                    >
                    <v-card
                        class="pa-2 text-center"
                        flat
                        width="300"
                    >
                        <div class="text-h5 mb-2">Join a Meeting</div>
                        <v-text-field label="MeetingID" outlined hide-details filled></v-text-field>
                        <v-btn color="success" width="100%" class="mt-2" large>Join</v-btn>
                    </v-card>
                </v-card>
            </div>
        </v-container>
    </div>
</template>


<script>

import { useAppStore } from '../stores/app'
import { useUserStore } from '../stores/user'

export default {
    name: 'MeetingParticipant',
    components: {},
    created: function() {
        this.app = useAppStore()
        this.user = useUserStore()
    },
    data() {
        return {
            app: null,
            user: null,
        }
    },
    mounted: function() {
        this.user.fetchUser()
        // this.app.getTwilioMeetingToken()

    },
    computed: {},
    methods: {
        
    },

}
</script>